import { render, staticRenderFns } from "./LocationPreferences.vue?vue&type=template&id=5c55a0e2&scoped=true&"
import script from "@/views/LocationPreferences/LocationPreferences.ts?vue&type=script&lang=ts&"
export * from "@/views/LocationPreferences/LocationPreferences.ts?vue&type=script&lang=ts&"
import style0 from "@/views/LocationPreferences/LocationPreferences.scss?vue&type=style&index=0&id=5c55a0e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c55a0e2",
  null
  
)

export default component.exports